"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEFormValidator = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const ArticleFormValidator_1 = require("../ArticleFormValidator");
class AEFormValidator {
    static gewicht(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 3,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.001,
        });
        const metricUnit = echain_shared_quantities_1.WeightUnits.kg;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 3,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.002, // 0.001 kg = 0.0022046226 lb
        });
        const imperialUnit = echain_shared_quantities_1.WeightUnits.lb;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static laenge(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 10,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0.4,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static count(options) {
        return ArticleFormValidator_1.ArticleFormValidator.anzahl(options);
    }
}
exports.AEFormValidator = AEFormValidator;
//# sourceMappingURL=AEFormValidator.js.map